export default {
  sidebar_items: {
    company: 'empresa',
    solutions: 'soluciones',
    profile: 'perfil',
    security: 'seguridad',
    integrations: 'integraciones',
    settings: 'configuración',
  },
}
